import React, { useCallback } from 'react'
import type { DirectionKind, NavigationCallback } from '..'

export const useCarousel = (onNavigationProps?: NavigationCallback) => {
  const [navigationCallback, setNavigationCallback] = React.useState<((direction: DirectionKind) => void) | undefined>() // prettier-ignore

  const onHandleNavigation = useCallback(
    (direction: DirectionKind) => {
      if (navigationCallback) {
        navigationCallback(direction)
        onNavigationProps?.(direction)
      }
    },
    [navigationCallback, onNavigationProps]
  )

  const onNavigation = useCallback((callback: (direction: DirectionKind) => void) => {
    setNavigationCallback(() => callback)
  }, [])

  return {
    onHandleNavigation,
    onNavigation,
  }
}
